import { createContext, useContext } from 'react';

export type AccountModalName =
  | 'ach'
  | 'adjustPaymentCap'
  | 'reCheck'
  | 'billingBlock'
  | 'directPayOptOut'
  | 'directPayOptIn'
  | 'enrollDomesticContent'
  | 'trancheHistory'
  | 'incentivesHistory'
  | 'oneTimePayment';

export type AccountModalType = AccountModalName | null;

export interface AccountDetailsContextValue {
  activeModal: AccountModalType;
  openModal: (type: AccountModalName) => void;
  closeModal: () => void;
  account: any;
  id: string;
  isLoading: boolean;
  claims: any;
  userPermissions: string[];
  isLightReachAdmin: boolean;
  isAccountEditEnabled: any;
}

export const AccountDetailsContext = createContext<AccountDetailsContextValue | null>(null);

export function useAccountDetailsContext(): AccountDetailsContextValue {
  const ctx = useContext(AccountDetailsContext);
  if (!ctx) {
    throw new Error('useAccountDetailsContext must be used within an AccountDetailsContext.Provider');
  }
  return ctx;
}
